/**
 * glør Variant Prefetch — lädt die Produktseite für eine Variante schon beim
 * Hover/Fokus im Hintergrund vor, damit der native variant-picker beim echten
 * Klick den Browser-Cache trifft und der Wechsel schneller wirkt.
 *
 * Update-sicher: greift NICHT in den nativen Picker ein, baut nur exakt dieselbe
 * Anfrage-URL (…?option_values=…) nach, die variant-picker.js beim Klick lädt,
 * und wärmt damit den Cache. Kein Core-Eingriff.
 */
const seen = new Set();

function viewParam() {
  return new URLSearchParams(location.search).get('view');
}

function prefetch(url) {
  if (!url || seen.has(url)) return;
  seen.add(url);
  fetch(url, { credentials: 'same-origin', priority: 'low' }).catch(() => {});
}

/**
 * Baut die URL nach dem Muster von variant-picker.js#buildRequestUrl:
 * option_values = pro Options-Gruppe die aktuell gewählte Wert-ID, aber für
 * die Gruppe des gehoverten Radios dessen Wert-ID.
 */
function buildUrl(picker, hovered, productUrl) {
  const fieldsets = Array.from(picker.querySelectorAll('fieldset'));
  const hoveredFs = hovered.closest('fieldset');
  const values = [];

  if (fieldsets.length) {
    for (const fs of fieldsets) {
      const r = fs === hoveredFs ? hovered : fs.querySelector('input[type="radio"]:checked');
      const id = r?.dataset.optionValueId;
      if (id) values.push(id);
    }
  } else if (hovered.dataset.optionValueId) {
    values.push(hovered.dataset.optionValueId);
  }
  if (!values.length) return '';

  const params = [];
  const v = viewParam();
  if (v) params.push('view=' + encodeURIComponent(v));
  params.push('option_values=' + values.join(','));
  return productUrl + '?' + params.join('&');
}

function setup(picker) {
  if (!(picker instanceof HTMLElement) || picker.dataset.glrPrefetch === 'on') return;
  const productUrl = (picker.dataset.productUrl || '').split('?')[0];
  if (!productUrl) return;
  picker.dataset.glrPrefetch = 'on';

  // Delegation am Picker-Element -> überlebt Section-Morphs beim Variantenwechsel.
  const onHover = (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const label = target.closest('label');
    if (!label || !picker.contains(label)) return;
    const radio = label.querySelector('input[type="radio"]');
    if (!(radio instanceof HTMLInputElement) || radio.checked) return;
    if (radio.getAttribute('aria-disabled') === 'true') return;
    prefetch(buildUrl(picker, radio, productUrl));
  };

  picker.addEventListener('mouseover', onHover, { passive: true });
  picker.addEventListener('focusin', onHover, { passive: true });
  picker.addEventListener('touchstart', onHover, { passive: true });
}

document.querySelectorAll('variant-picker').forEach(setup);
